




































































































import Vue from "vue";
import NamedButton from "@/components/basic/buttons/NamedButton.vue";
import { DataUploadMethod } from "@/constants/form-values";
import { SET_PROGRESS } from "@/constants/mutation-types";
import { Device } from "@/constants/form-values";
import { Locale } from "@/constants/locale";
import { UtilityHelper } from "@/helpers/UtilityHelper";

export default Vue.extend({
  name: "dataUploadChoice",
  data() {
    return {
      Option: Device,
      DataUploadMethod,
      TRANSLATION_KEY: "steps.DataUploadChoice",
      Locale,
      UtilityHelper,
    };
  },
  mounted() {
    this.$store.commit(SET_PROGRESS, 7);
  },
  components: {
    NamedButton,
  },
});
